
import Link from 'next/link';
import { useRouter } from 'next/router';
import { MouseEvent, useContext } from 'react';
import { AppCustomContext } from '@/context/index';
import { isUrlAbsolute, isUrlRootRelative } from '@/utilities/functions';

const CustomLink = ({ className, href, onClick, openOnNewTab, text, children }: {
	className?: any;
	href?: string;
	openOnNewTab?: boolean;
	onClick?: () => void;
	text?: string;
	children?: any;
}) => {

	const router = useRouter();
	const appContext = useContext(AppCustomContext);
	const url = href ? (
		isUrlAbsolute(href)
			? href
			: isUrlRootRelative(href)
				? `/${appContext.currentLocale}${href}`.replace('//', '/')
				: `/${appContext.currentLocale}/${appContext.currentPath}/${href}`.replace('//', '/')
	) : (
		''
	);

	// Check if the target URL is the same as the current URL to prevent navigation errors
	const isSameUrl = !isUrlAbsolute(href || '') && url === router.asPath;

	const handleClick = (e: MouseEvent) => {
		if (isSameUrl) {
			e.preventDefault();
			return false;
		}
		if (onClick) {
			onClick();
		}
	};

	return (
		<span onClick={handleClick}>
			{href ? (
				<Link
					className={className}
					href={url}
					locale={isUrlAbsolute(href) ? undefined : appContext.currentLocale}
					rel='noreferrer noopener'
					target={openOnNewTab ? '_blank' : ''}
				>
					{text} {children}
				</Link>
			) : (
				<a className={className} target={openOnNewTab ? '_blank' : ''} rel='noreferrer noopener'> {text} {children} </a>
			)}
		</span>
	);
};

export default CustomLink;
